<template>
  <transition-group
    :name="transitionName"
    tag="ul"
    class="carousel-list"
    @before-enter="beforeEnter"
    @after-leave="afterLeave"
    :style="containerCssStyles"
  >
    <li
      v-touch:swipe.left="handleSwipeLeft"
      v-touch:swipe.right="handleSwipeRight"
      v-for="slide in slides"
      v-show="slide.id === currId"
      :class="{ active: slide.id == currId }"
      :key="slide.id"
      class="carousel-item"
      ref="items"
    >
      <slot :slide="slide"></slot>
    </li>
  </transition-group>
</template>

<script>
export default {
  name: 'CarouselList',
  data: function() {
    return {
      containerCssStyles: {},
    }
  },
  props: {
    transitionName: {
      type: String,
      required: true,
    },
    slides: {
      type: Array,
      required: true,
    },
    currId: {
      type: Number,
      required: true,
    },
  },

  inject: ['transitionFalse', 'transitionTrue'],

  mounted: function() {},

  computed: {},

  methods: {
    beforeEnter: function() {
      this.$emit('before-enter')
    },

    afterLeave: function() {
      this.$emit('after-leave')
    },

    handleSwipeLeft: function() {
      this.$emit('swipe', {
        direction: 'prev',
      })
    },

    handleSwipeRight: function() {
      this.$emit('swipe', {
        direction: 'next',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.carousel-list {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
}
.carousel-item {
  width: 100%;
  height: 100%;
  flex-grow: 1;
  flex-basis: 1;
  flex-shrink: 1;
  position: absolute;
}
.active {
  position: static;
}
</style>

<!--CAROUSEL TRANSITIONS-->
<style lang="scss" scoped>
.next-enter {
  transform: translateX(-100%);
}
.next-enter-to {
  transform: translateX(0);
}

.next-leave {
  transform: translateX(0);
}
.next-leave-to {
  transform: translateX(100%);
}

.next-enter-active,
.next-leave-active {
  transition: all 500ms ease;
}

.prev-enter {
  transform: translateX(100%);
}
.prev-enter-to {
  transform: translateX(0);
}

.prev-leave {
  transform: translateX(0);
}
.prev-leave-to {
  transform: translateX(-100%);
}

.prev-enter-active,
.prev-leave-active {
  transition: all 500ms ease;
}
</style>
